/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_ApikeysInputs */

const en_settings_nav_apikeys = /** @type {(inputs: Settings_Nav_ApikeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Keys`)
};

/**
* | output |
* | --- |
* | "API Keys" |
*
* @param {Settings_Nav_ApikeysInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_nav_apikeys = /** @type {((inputs?: Settings_Nav_ApikeysInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_ApikeysInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_nav_apikeys(inputs)
});
export { settings_nav_apikeys as "settings.nav.apikeys" }